export const parseAlphabeticalOrder = (array: any) => {
    const result =  array.sort(function(a: any ,b: any) {
        return a.label.toLowerCase() < b.label.toLowerCase() ? -1 : a.label.toLowerCase() > b.label.toLowerCase() ? 1 : 0;
    });
    return result
  }

